import React from 'react';
import {useQuery} from "react-query";
import {useClient, useUserContext} from "../../hooks";
import {Alert} from "reactstrap";

export function SafeguardingDeclarationsCoreTeamAlert() {
  const { isCoreTeamMember, isCoordinator } = useUserContext();
  const client = useClient();
  const url = 'me/safeguarding_status';

  const { data } = useQuery({
    queryKey: [url],
    queryFn: () => client.get(url).get('data'),
    config: {
      cacheTime: 0,
      useErrorBoundary: false,
      enabled: !!(isCoreTeamMember || isCoordinator)
    }
  })

  if (!data || !data.id || data.submitted) return null;

  return (
    <Alert color="warning" className="d-print-none">
      Please ensure you complete your Safeguarding Declaration for this year - it should only take you a few moments and you can do so by following this link: <a href={data.link}>View Declaration</a>
    </Alert>
  )
}